// TODO: Remove in favour of the nova-price component
import { LitElement, classMap, css, html, nothing } from '@lit'
import styles from '@nova/styles'

class ProductCardPrice extends LitElement {
  static properties = {
    price: { type: String },
    compareAtPrice: { type: String },
  }

  constructor() {
    super()
    this.price = ''
    this.compareAtPrice = ''
  }

  render() {
    const isOnSale = !!this.compareAtPrice;
    const showRegularOnly = !isOnSale;

    return html`
      <div class=${classMap({
        price: true,
        'price--on-sale': isOnSale,
      })}>
        ${showRegularOnly
          ? html`
              <span class="price-item price-item--regular price__regular">
                <span class="visually-hidden">${window.priceStrings?.regularPrice || 'Regular price'}</span>
                ${this.price}
              </span>
            `
          : html`
              <span class="price-item price-item--sale price__sale">
                <span class="visually-hidden">${window.priceStrings?.salePrice || 'Sale price'}</span>
                <span>${this.price}</span>
              </span>
              <span class="price-item price-item--compare price__sale">
                <span class="visually-hidden">${window.priceStrings?.regularPrice || 'Regular price'}</span>
                <s>${this.compareAtPrice}</s>
              </span>
            `}
      </div>
    `;
  }


  static styles = [
    styles.reset,
    styles.a11y,
    styles.flex,
    styles.helpers,
    styles.typography,
    styles.skeleton,
    css`
      .price {
        align-items: center;
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        color: rgb(var(--color-foreground));
      }

      .price--align-left {
        align-items: flex-start;
      }

      .price.price--unavailable {
        visibility: hidden;
      }

      .price--end {
        justify-content: flex-end;
      }

      .price {
        margin: 0;
        display: flex;
      }

      .price .price__last:last-of-type {
        margin: 0;
      }

      @container (min-width: 300px) {
        .price {
          margin-bottom: 0;
        }
      }

      .price--sold-out .price__availability,
      .price__regular {
        display: block;
        margin: 0;
      }

      .price__sale,
      .price__availability,
      .price .price__badge-sale,
      .price .price__badge-sold-out,
      .price--on-sale .price__regular,
      .price--on-sale .price__availability,
      .price--no-compare .price__compare {
        display: none;
      }

      .price-item--sale {
        color: var(--nova-on-sale);
      }

      .price--sold-out .price__badge-sold-out,
      .price--on-sale .price__badge-sale {
        display: inline-flex;
      }

      .price__sale dd + dt {
        margin-right: 5px;
      }

      .price--on-sale .price__sale {
        display: inline;
        flex-direction: row;
        margin-right: 5px;
        margin-left: 0;
      }

      .price--center {
        display: flex;
        justify-content: center;
      }

      .price--on-sale .price-item--regular {
        text-decoration: line-through;
        color: var(--nova-brand-subdued, rgba(0, 0, 0, 0.8));
      }
    `,
  ]
}

customElements.define('nova-product-card-price', ProductCardPrice)
